import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import React, { FC } from "react";
import { ExpertRole } from "../../data/constants";
import { AssignedUserViewModel } from "../../model/AssignedUserViewModel";
import { RoomAssignmentViewModel } from "../../model/RoomAssignmentViewModel";
import RoomAssignmentCard from "../roomAssignment/RoomAssignmentCard";
import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import { ExamSessionViewModel } from "../../model/ExamSessionViewModel";
import RoomAssignmentExpertSelect from "./RoomAssignmentExpertSelect";
import { ExpertViewModel } from "../../model/ExpertViewModel";

interface RoomAssignmentRowProps {
  examSession: ExamSessionViewModel;
  allExperts: ExpertViewModel[] | undefined;
  expertRole: ExpertRole;
  fixedExpertsLabel: JSX.Element;
  fixedExpertsPlaceholder: JSX.Element;
  reserveExpertsLabel: JSX.Element;
  reserveExpertsPlaceholder: JSX.Element;
  minimumFixedUsers: number;
  showAllExperts: boolean;
  examDay: ExamDayViewModel;
  roomAssignment: RoomAssignmentViewModel;
  change: (isFixed: boolean, experts: AssignedUserViewModel[]) => void;
}

const RoomAssignmentRow: FC<RoomAssignmentRowProps> = ({
  examSession,
  allExperts,
  expertRole,
  fixedExpertsLabel,
  fixedExpertsPlaceholder,
  reserveExpertsLabel,
  reserveExpertsPlaceholder,
  minimumFixedUsers,
  showAllExperts,
  examDay,
  roomAssignment,
  change,
}) => {
  if (allExperts === undefined) {
    return <></>;
  }

  return (
    <>
      <ListItem alignItems="flex-start">
        <Grid container={true} spacing={4}>
          <Grid item={true} xs={12} lg={4}>
            <RoomAssignmentCard
              examSession={examSession}
              roomAssignment={roomAssignment}
              locationId={examDay.locationId}
              isReadOnly={true}
              isUserRoomAssignment={true}
            />
          </Grid>
          <Grid container={true} item={true} spacing={4} xs={12} lg={8}>
            <Grid item={true} xs={12}>
              <RoomAssignmentExpertSelect
                showAllExperts={showAllExperts}
                examDay={examDay}
                examSession={examSession}
                isFixedExpert
                expertRole={expertRole}
                label={fixedExpertsLabel}
                placeholder={fixedExpertsPlaceholder}
                roomAssignment={roomAssignment}
                allExperts={allExperts}
                minimumUsers={minimumFixedUsers}
                change={change}
              />
            </Grid>
            <Grid item={true} xs={12}>
              <RoomAssignmentExpertSelect
                showAllExperts={showAllExperts}
                examDay={examDay}
                examSession={examSession}
                isFixedExpert={false}
                expertRole={expertRole}
                label={reserveExpertsLabel}
                placeholder={reserveExpertsPlaceholder}
                roomAssignment={roomAssignment}
                allExperts={allExperts}
                change={change}
              />
            </Grid>
          </Grid>
        </Grid>
      </ListItem>
      <Divider component="li" />
    </>
  );
};

export default RoomAssignmentRow;
